import React, { useEffect, useRef, useState } from 'react';
import cx from 'classnames';
import { Button, useEscape } from 'library';

import WistiaVideo from '../WistiaVideo/WistiaVideo';

import './WistiaVideoOverlay.scss';

const WistiaVideoOverlay = ({ videoId, ctaText, className }) => {
  const [overlay, setOverlay] = useState(false);
  const [isReady, setIsReady] = useState(false);
  const videoContainer = useRef();

  useEscape(overlay, () => {
    setOverlay(false);
  });

  // Move focus to video when lightbox is opened and video is ready
  useEffect(() => {
    if (overlay && isReady && videoContainer.current) {
      handleVideoFocus();
    }
  }, [overlay, isReady, videoContainer]);

  const handleVideoFocus = () => {
    const playButton = videoContainer.current.querySelector('button');
    if (playButton) {
      playButton.focus();
    }
  };

  const toggleOverlay = () => {
    setOverlay(!overlay);
  };

  return (
    <div className={cx('WistiaVideoOverlay', className)}>
      <div className={cx('WistiaVideoOverlayWrap', { Show: overlay })}>
        <div className="WistiaVideoLightbox" role="dialog" aria-modal>
          <div className="WistiaVideoComponent" ref={videoContainer}>
            <WistiaVideo
              videoId={videoId}
              onReady={() => {
                setIsReady(true);
              }}
            />
          </div>
          <button className="WistiaVideoClose" onClick={toggleOverlay}>
            <span className="X">x</span> Close
          </button>
          <button style={{ opacity: 0 }} onFocus={handleVideoFocus} aria-label="video overlay end" />
        </div>
      </div>
      <Button className="WistiaVideoOverlayButton" icon="icon-video" theme="text" onClick={toggleOverlay}>
        {ctaText}
      </Button>
    </div>
  );
};

export default WistiaVideoOverlay;
